export const UPDATE_CREATION_FORM = "UPDATE_CREATION_FORM";

export const SET_CURRENT_REGISTRATION = "SET_CURRENT_REGISTRATION";
